/* eslint-disable */
export default {
  copyToClipboard: 'Copy to Clipboard',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
